
import { NavUserCard } from '@/components/custom/nav-user-card'
import { SidebarUsageWidget } from '@/components/custom/sidebar-usage-widget'
import BrandTitle from '@/components/custom/brand'
import { MainNavMenu } from '@/components/nav-main'
import { Sidebar, SidebarHeader, SidebarInset, SidebarProvider } from '@/shared/components/ui/sidebar'

const DashboardLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <SidebarProvider>
            <Sidebar className="border-r-0">
                <SidebarHeader>
                    <BrandTitle />
                    <MainNavMenu />
                </SidebarHeader>
                <div className="mt-auto">
                    <SidebarUsageWidget />
                    <NavUserCard />
                </div>
            </Sidebar>
            <SidebarInset>
                {/*  <header className="sticky top-0 flex h-16 shrink-0 items-center gap-2 border-b bg-background px-4 z-50">
                    <SidebarTrigger className="-ml-1" />
                    <Separator orientation="vertical" className="mr-2 h-4" />
                </header> */}
                {children}
            </SidebarInset>
        </SidebarProvider>
    )
}

export default DashboardLayout
